import {Colors, IconMenuItem} from "../../ui";
import {ReactNode} from "react";
import {IconMenuItemProps} from "../../ui/components/IconMenuItem";

interface Props {
  label: IconMenuItemProps["label"];
  value?: string;
  icon?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  hasHover?: boolean;
  color?: string;
  borderRadius?: string;
  padding?: string;
  height?: string;
  fontWeight?: number | "medium";
}

export const CustomMenuItem = ({
  label,
  value,
  icon,
  onClick,
  disabled = false,
  hasHover = true,
  padding = "8px",
  color = Colors.primary._800,
  fontWeight = "medium",
}: Props) => {
  const iconMenuItemStyles = {
    menuItem: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      padding,
      minHeight: "0",
      borderRadius: "8px",
      "&:hover, &:active": {
        background: hasHover ? Colors.primary._100 : "transparent",
      },
      color,
    },
  };

  return (
    <IconMenuItem
      label={label}
      value={value}
      icon={icon}
      onClick={onClick}
      sx={iconMenuItemStyles.menuItem}
      divider={false}
      disabled={disabled}
      fontWeight={fontWeight}
      color={color}
    />
  );
};
